// Affiliate ref capture: ?ref=CODE is stored on first visit and appended to buy links.
const REF_KEY = 'idolaris_ref';

export function captureRef() {
  try {
    const p = new URLSearchParams(window.location.search);
    const ref = p.get('ref');
    if (ref) localStorage.setItem(REF_KEY, ref.trim());
  } catch { /* noop */ }
}

export function getRef() {
  try { return localStorage.getItem(REF_KEY) || ''; } catch { return ''; }
}

export function withRef(url) {
  if (!url) return url;
  const ref = getRef();
  if (!ref) return url;
  try {
    const u = new URL(url);
    if (!u.searchParams.has('ref')) u.searchParams.set('ref', ref);
    return u.toString();
  } catch {
    const sep = url.includes('?') ? '&' : '?';
    return `${url}${sep}ref=${encodeURIComponent(ref)}`;
  }
}
